/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface SearchLineageRequest {
    effectTenantId?: string;
    inboundFromInstanceTenantId?: string;
    executionId?: string;
    page?: number;
    size?: number;
    sessionId?: string;
}

/**
 * IntegrationMarketplaceLineageApi - interface
 * 
 * @export
 * @interface IntegrationMarketplaceLineageApiInterface
 */
export interface IntegrationMarketplaceLineageApiInterface {
    /**
     * List lineage rows for effective tenants. Use effectTenantId for effect-tenant inbound view; inboundFromInstanceTenantId for rows written from a hub tenant; executionId to scope to one run.
     * @summary Search integration data lineage
     * @param {string} [effectTenantId] Filter by effect tenant (lineage tenant_id)
     * @param {string} [inboundFromInstanceTenantId] Filter inbound rows from this hub (instance) tenant id
     * @param {string} [executionId] Execution workflow id or integration_executions.id
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceLineageApiInterface
     */
    searchLineageRaw(requestParameters: SearchLineageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * List lineage rows for effective tenants. Use effectTenantId for effect-tenant inbound view; inboundFromInstanceTenantId for rows written from a hub tenant; executionId to scope to one run.
     * Search integration data lineage
     */
    searchLineage(requestParameters: SearchLineageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class IntegrationMarketplaceLineageApi extends runtime.BaseAPI implements IntegrationMarketplaceLineageApiInterface {

    /**
     * List lineage rows for effective tenants. Use effectTenantId for effect-tenant inbound view; inboundFromInstanceTenantId for rows written from a hub tenant; executionId to scope to one run.
     * Search integration data lineage
     */
    async searchLineageRaw(requestParameters: SearchLineageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['effectTenantId'] != null) {
            queryParameters['effectTenantId'] = requestParameters['effectTenantId'];
        }

        if (requestParameters['inboundFromInstanceTenantId'] != null) {
            queryParameters['inboundFromInstanceTenantId'] = requestParameters['inboundFromInstanceTenantId'];
        }

        if (requestParameters['executionId'] != null) {
            queryParameters['executionId'] = requestParameters['executionId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/lineage`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * List lineage rows for effective tenants. Use effectTenantId for effect-tenant inbound view; inboundFromInstanceTenantId for rows written from a hub tenant; executionId to scope to one run.
     * Search integration data lineage
     */
    async searchLineage(requestParameters: SearchLineageRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.searchLineageRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
